import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export const HelpSupport = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f5f5f5] min-h-screen pt-20 pb-20">
      <div className="flex justify-center">
        <div className="w-[98%]">
          <div className="flex items-center gap-4 mb-5">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-gray-200 rounded-full transition-colors"
            >
              <IoArrowBackOutline className="text-[24px] text-gray-700" />
            </button>
            <h1 className="text-[24px] font-semibold">Ajuda e Suporte</h1>
          </div>

          <div className="bg-white p-6 rounded-[18px] shadow-sm">
            <p className="text-gray-600 mb-6">
              Precisa de ajuda? Entre em contato conosco.
            </p>

            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
                <p className="text-gray-600">suporte@duasvidas.com.br</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Telefone</h3>
                <p className="text-gray-600">(11) 1234-5678</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  Horário de Atendimento
                </h3>
                <p className="text-gray-600">Segunda a Sexta: 8h às 18h</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
